export class EducationVerificationModel {
    OrderId: string;
    SchoolName: string;
    City: string;
    State: string;
    PhoneNumber: any;
    FaxNumber: string;
    StartDate: any;
    Degree: string;
    Status: string = 'New';
    Major: string;
    EndDate: any;
    ReviewMode: boolean = false;
    Id: string;
    CurrentlyEnrolled: boolean;
    EnrolementNumber: string;
    FullDateOfJoining: string;
    EntryInWhichCase: string;
    EditMobileNumber: string;
    UserEmail: string;
    GraduationDate: any;
};